import React, { Component } from "react";
import Tippy from "tippy.js";
import "./tooltip.scss";

export default class Tooltip extends Component {
  constructor(props) {
    super(props);

    const randomId = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "");

    const tippyConf = {
      animation: "shift",
      size: "regular",
      theme: "qbox",
      html: this.props.title && "#with-title" + randomId,
      duration: 200,
      arrow: false,
      flipDuration: 0,
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: false,
          },
          hide: {
            enabled: false,
          },
        },
      },
    };

    this.state = {
      randomId,
      tippyConf,
    };
  }

  componentDidMount() {
    const tippy = Tippy(`#${this.state.randomId}`, this.state.tippyConf);
    this.setState({ tippy });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.text !== this.props.text) {
      // update the Tippy https://atomiks.github.io/tippyjs/#methods
      const el = document.querySelector(`#${prevState.randomId}`);
      if (!el) return;
      const popper = this.state.tippy.getPopperElement(el);
      if (!popper) return;
      this.state.tippy.update(popper);
    }
  }

  componentWillUnmount() {
    if (this.state.tippy) {
      const el = document.querySelector(`#${this.state.randomId}`);
      if (!el) return;

      const popper = this.state.tippy.getPopperElement(el);
      if (!popper) return;
      this.state.tippy.destroy(popper);
    }
  }

  renderMessageWithTitle() {
    return (
      <div id={"with-title" + this.state.randomId} style={{ display: "none" }}>
        <p className="tooltip-title">{this.props.title}</p>
        {this.props.text}
      </div>
    );
  }

  render() {
    const { className = "", text, children, withAction, title, containerStyle = {} } = this.props;
    return (
      <div style={{ ...containerStyle }} className={className}>
        {React.cloneElement(children, { title: text, id: this.state.randomId })}
        {withAction && this.renderMessageWithAction()}
        {title && this.renderMessageWithTitle()}
      </div>
    );
  }
}
